import { useState, useEffect } from "react";
import MaterialTable from "@material-table/core";
import * as APIModels from "../../../models";
import { TylerPaymentService } from "../../../services/ClientService";
import { Endpoints } from "../../../helpers/Endpoints";
import CreatePaymentMethodModal from "./modals/CreatePaymentMethodModal";

async function getAll(): Promise<APIModels.PaymentMethod[]> {
    const response = await TylerPaymentService.getAll();
    if (response.successful && response.data) {
        return response.data;
    } else {
        throw new Error(response.errorMessage);
    }
}

async function get(id: string): Promise<APIModels.PaymentMethod> {
    const response = await TylerPaymentService.get({ id });
    if (response.successful && response.data) {
        return response.data;
    } else {
        throw new Error(response.errorMessage);
    }
}

async function add(paymentMethod: APIModels.PaymentMethod): Promise<string> {
    const response = await TylerPaymentService.add({ body: paymentMethod });
    if (response.successful) {
        return "Created Successfully";
    } else {
        throw new Error(response.errorMessage);
    }
}

async function update(paymentMethod: APIModels.PaymentMethod): Promise<string> {
    const response = await TylerPaymentService.update({ body: paymentMethod });
    if (response.successful) {
        return "Updated Successfully";
    } else {
        throw new Error(response.errorMessage);
    }
}

async function remove(id: string): Promise<string> {
    const response = await TylerPaymentService.delete({ id });
    if (response.successful) {
        return "Deleted Successfully";
    } else {
        throw new Error(response.errorMessage);
    }
}

export default function TylerPaymentMethods(): JSX.Element {
    const [data, setData] = useState([] as APIModels.PaymentMethod[]);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [modal, setModal] = useState(false);

    useEffect(() => {
        document.title = "Payment Methods";
        setSuccess("");
        setError("");
        getAll()
            .then((res) => {
                setSuccess("Loaded Successfully");
                setData(res);
            })
            .catch((err) => {
                setError(err.message);
            });
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <CreatePaymentMethodModal
                    modal={modal}
                    setModal={setModal}
                    callback={() => {
                        console.log("callback");
                        setSuccess("Created Successfully");
                        getAll()
                            .then((res) => {
                                setData(res);
                            })
                            .catch((err) => {
                                setError(err.message);
                            });
                    }}
                    setMessage={(value: string, isError: boolean) => {
                        if (isError) {
                            setError(value);
                        } else {
                            setSuccess(value);
                        }
                    }}
                />
                <button
                    className="btn btn-primary p-2 mb-2 w-25"
                    onClick={() => {
                        setModal(true);
                    }}
                >
                    <span>Add a new Payment Method</span>
                </button>
                <MaterialTable
                    title="Payment Methods"
                    columns={[
                        {
                            title: "Payment Account Name",
                            field: "accountName",
                        },
                        {
                            title: "Payment Account Type",
                            field: "paymentAccountTypeCode",
                        },
                        { title: "Active", field: "active" },
                    ]}
                    data={data}
                    editable={{}}
                />
            </div>
            {error !== "" && (
                <div className="col-12 p-2">
                    <div className="alert alert-danger">{error}</div>
                </div>
            )}
            {success !== "" && (
                <div className="col-12 p-2">
                    <div className="alert alert-success">{success}</div>
                </div>
            )}
        </div>
    );
}
